var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCheckRound = function SvgIconCheckRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#009DE7",
    d: "M8 15.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.89 5.915a.594.594 0 0 0-.84 0l-3.951 3.95L5.09 7.859a.594.594 0 0 0-.84.84l2.256 2.257a.837.837 0 0 0 1.184 0l4.199-4.2a.594.594 0 0 0 0-.84"
  })));
};
export default SvgIconCheckRound;